<template>
    <section class="screen-home">
        <header class="header">
            <h1>ⅹⅹⅹ vandaag in amsterdam ⅹⅹⅹ</h1>

            <p>
                Wat er vandaag, morgen en overmorgen te doen is in Amsterdam.
                <a href="#about">Meer informatie</a>.
            </p>
        </header>

        <main-menu></main-menu>

        <div class="events">
            <header class="events__header">
                <h2 class="events__date">
                    {{dateFormatted}}
                </h2>

                <p class="events__note">
                    <template v-if="feed.length === 0">
                        Alle evenementen van vandaag zijn afgelopen 😭.<br />
                        Je kunt zien wat er <a href="#1">morgen te doen is</a> of
                        <button class="events__link" v-on:click="showPastEvents">wat je gemist hebt</button>.
                    </template>

                    <template v-else-if="feed.length === 1">
                        <strong>{{feed.length}}</strong> evenement gevonden.
                    </template>

                    <template v-else>
                        <strong>{{feed.length}}</strong> evenementen gevonden.
                    </template>
                </p>
            </header>

            <ul>
                <li v-for="(item, index) in feed"
                    v-bind:key="index"
                    class="events__event">
                    <event-item v-bind:item="item"></event-item>
                </li>
            </ul>

            <footer class="events__footer">
                Dat was het voor {{dayFull}}.
            </footer>
        </div>

        <footer id="about" class="footer">
            <p>
                <strong>Vandaag in Amsterdam</strong> verzamelt evenementen
                van meerdere bronnen om te laten zien wat je vandaag, morgen en
                overmorgen in Amsterdam kan doen.
            </p>

            <p>
                Deze site is een hobbyproject van
                <a href="https://www.haykranen.nl/?ref=vanavond-in-amsterdam">Hay Kranen</a>.
                Ik werd een beetje moe van sites afspeuren op zoek
                naar leuke dingen om te doen in de stad. Dus daarom deze site.
            </p>

            <p>
                <a href="https://www.haykranen.nl/2021/09/14/geen-plaatjes/">Waarom staan er geen plaatjes op deze site?</a>
            </p>

            <p>
                Ik heb trouwens ook nog een leuke <a href="http://haykranen.nl/circulaire/?ref=vandaag">nieuwsbrief</a>.
            </p>

            <p>
                Op dit moment komt de data van {{sources}}.
            </p>
        </footer>
    </section>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import EventItem from './event-item.vue';
    import MainMenu from './main-menu.vue';
    import { wordConcat } from '../util.js';

    export default {
        components : { EventItem, MainMenu },

        computed : {
            ...mapGetters([ 'date', 'dates', 'dateFormatted', 'dayFull', 'feed' ]),
            ...mapState([ 'dateIndex' ]),

            sources() {
                const origins = Object.values(this.$store.state.origins).map(o => o.label);
                return wordConcat(origins, 'en');
            }
        },

        methods : {
            showPastEvents() {
                this.$store.commit('showPastEvents', true);
            }
        }
    }
</script>